export { Areas as default } from './areas';
